export default "__VITE_ASSET__DfQ3fg_c__"